import { useRef } from 'react';
// @mui
import { AppBar, Box, BoxProps, Container, Link, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// hooks
// utils
import { bgBlur } from '../../utils/cssStyles';
// config
import { HEADER } from '../../config-global';
// components
import Logo from '../../components/logo';

// ----------------------------------------------------------------------

export default function Header() {
  const carouselRef = useRef(null);

  const theme = useTheme();

  // const isDesktop = useResponsive('up', 'md');

  // const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);
  // quick fix: navbar
  const isOffset = true;

  const headerOptions = {
    Überblick: 'https://gooogle.com',
    'Unser Ansatz': 'https://gooogle.com',
    Team: 'https://gooogle.com',
  };

  return (
    <AppBar ref={carouselRef} color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        disableGutters
        sx={{
          // height: {
          //   xs: HEADER.H_MOBILE,
          //   md: HEADER.H_MAIN_DESKTOP,
          // },
          transition: theme.transitions.create(['height', 'background-color'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: HEADER.H_MAIN_DESKTOP - 16,
            },
          }),
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          {/* Left Section: Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logo />
          </Box>

          {/* Middle Section: Header Options, centered */}
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center', // This will center the header options horizontally
              alignItems: 'center',
            }}
          >
            {Object.entries(headerOptions).map(([option, url]) => (
              <Link
                key={option}
                href={url}
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{ ml: 2, color: theme.palette.text.primary }}
              >
                {option}
              </Link>
            ))}
          </Box>

          {/* Right Section: Contact Us */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link
              href="https://google.com"
              target="_blank"
              rel="noopener"
              underline="none"
              sx={{
                ml: 2,
                px: 2,
                py: 1,
                // borderRadius: 5,
                bgcolor: 'primary.main',
                color: 'common.white',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              }}
            >
              Contact us
            </Link>
          </Box>
        </Container>
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
}

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 48px)`,
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
